import dayjs from 'dayjs';
import React, { Dispatch, SetStateAction } from 'react';
import { CalendarChallenge } from 'src/types/shared/Challenge';
import { getDateRangeFromChallenge } from '../../utils/generic';
import * as isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { calendarBarColors } from '@constants/calendar';
import CalendarGanttBar from './CalendarGanttBar';

//@ts-ignore
dayjs.extend(isSameOrAfter);
//@ts-ignore
dayjs.extend(isSameOrBefore);

const CalendarSpanBar: React.FC<CalendarGanttBarProps> = ({
    challenge,
    calendarStartDate,
    calendarEndDate,
    isExpanded = false,
}) => {
    const {
        id,
        workshopDate,
        startDate,
        endDate,
        assessmentStartDate,
        responseDate,
        pitchPresentationDate,
    } = challenge;
    const { start, end } = getDateRangeFromChallenge(challenge);

    const startIsOutOfRange = dayjs(start).isSameOrBefore(dayjs(calendarStartDate));
    const endIsOutOfRange = dayjs(end).isSameOrAfter(dayjs(calendarEndDate));

    const sD = {
        y: start.format('YYYY'),
        m: start.format('MM'),
        d: start.format('DD'),
    };
    const eD = { y: end.format('YYYY'), m: end.format('MM'), d: end.format('DD') };

    const gridRowStart = `challenge-${id}-start`;
    const gridRowEnd = `challenge-${id}-end`;
    const gridColumnStart = startIsOutOfRange ? 'sidebar-end' : `start-${sD.y}-${sD.m}-${sD.d}`;
    const gridColumnEnd = endIsOutOfRange ? 'cols-end' : `end-${eD.y}-${eD.m}-${eD.d}`;

    const newSpanBarStyles = {
        gridArea: `${gridRowStart} / ${gridColumnStart} / ${gridRowEnd} / ${gridColumnEnd}`,
    };
    return isExpanded ? (
        <div className="challenge-span-bar" style={newSpanBarStyles}>
            {!startIsOutOfRange && <span className="span-node left" />}
            {!endIsOutOfRange && <span className="span-node right" />}
        </div>
    ) : (
        <>
            <CalendarGanttBar
                id={id}
                stage={'workshop'}
                barStartDate={workshopDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.workshop}
                challenge={challenge}
                isExpanded={false}
            />
            <CalendarGanttBar
                id={id}
                stage={'livechallenge'}
                barStartDate={startDate}
                barEndDate={endDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.livechallenge}
                challenge={challenge}
                isExpanded={false}
            />
            <CalendarGanttBar
                id={id}
                stage={'assessment'}
                barStartDate={assessmentStartDate}
                barEndDate={responseDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.assessment}
                challenge={challenge}
                isExpanded={false}
            />
            <CalendarGanttBar
                id={id}
                stage={'pitch'}
                barStartDate={pitchPresentationDate}
                calendarStartDate={calendarStartDate}
                calendarEndDate={calendarEndDate}
                color={calendarBarColors.pitch}
                challenge={challenge}
                isExpanded={false}
            />
        </>
    );
};

interface CalendarGanttBarProps {
    challenge: CalendarChallenge;
    calendarStartDate: Date | string;
    calendarEndDate: Date | string;
    isExpanded: boolean;
}

export default CalendarSpanBar;
